import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5acc95b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "TUTTI", -1))
const _hoisted_3 = { class: "btn-group" }
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("tr", null, [
        _hoisted_2,
        _createElementVNode("td", null, [
          (_ctx.ris.length == 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-small btn-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectAll(true)))
              }, "Seleziona"))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-small btn-primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectAll(false)))
              }, "Deseleziona"))
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
        return (_openBlock(), _createElementBlock("tr", { key: i }, [
          _createElementVNode("td", null, _toDisplayString(item.name), 1),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                ref_for: true,
                ref: "chekky",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ris) = $event)),
                value: item.identifier
              }, null, 8, _hoisted_4), [
                [_vModelCheckbox, _ctx.ris]
              ])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}